module.exports = __webpack_public_path__ + "static/media/spinner.fd6fb244.gif";